/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_ConsoleInputs */

const en_admin_console = /** @type {(inputs: Admin_ConsoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin Console`)
};

const es_admin_console = /** @type {(inputs: Admin_ConsoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consola de administración`)
};

const fr_admin_console = /** @type {(inputs: Admin_ConsoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Console d'administration`)
};

const de_admin_console = /** @type {(inputs: Admin_ConsoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Konsole`)
};

const ja_admin_console = /** @type {(inputs: Admin_ConsoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理コンソール`)
};

const zh_admin_console = /** @type {(inputs: Admin_ConsoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理控制台`)
};

const ar_admin_console = /** @type {(inputs: Admin_ConsoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وحدة تحكم المسؤول`)
};

const id_admin_console = /** @type {(inputs: Admin_ConsoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsol Admin`)
};

const it_admin_console = /** @type {(inputs: Admin_ConsoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Console Amministratore`)
};

const ru_admin_console = /** @type {(inputs: Admin_ConsoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Консоль администратора`)
};

const pt_admin_console = /** @type {(inputs: Admin_ConsoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Console de Administração`)
};

const ko_admin_console = /** @type {(inputs: Admin_ConsoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`관리자 콘솔`)
};

/**
* | output |
* | --- |
* | "Admin Console" |
*
* @param {Admin_ConsoleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const admin_console = /** @type {((inputs?: Admin_ConsoleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_ConsoleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_console(inputs)
	if (locale === "es") return es_admin_console(inputs)
	if (locale === "fr") return fr_admin_console(inputs)
	if (locale === "de") return de_admin_console(inputs)
	if (locale === "ja") return ja_admin_console(inputs)
	if (locale === "zh") return zh_admin_console(inputs)
	if (locale === "ar") return ar_admin_console(inputs)
	if (locale === "id") return id_admin_console(inputs)
	if (locale === "it") return it_admin_console(inputs)
	if (locale === "ru") return ru_admin_console(inputs)
	if (locale === "pt") return pt_admin_console(inputs)
	return ko_admin_console(inputs)
});